import Vue from 'vue';

export const bus = new Vue();

export const stickyRefresh = () => {
    bus.$emit('possible-resize');
};

window.__odrBus = bus;

export default { bus, stickyRefresh };
